import type { FC } from 'react';
import { ReactComponent as PlugsConnectedIcon } from 'assets/icons/trial-miner-icons/plugs-connected.svg';

import * as S from './TrialStartDelayBanner.styled';

interface IPropsTrialStartDelayBanner {
  t: (key: string) => string;
}

export const TrialStartDelayBanner: FC<IPropsTrialStartDelayBanner> = ({ t }) => {
  return (
    <S.TrialStartDelayBanner>
      <S.LaunchContentWrapper>
        <PlugsConnectedIcon width={16} height={16} />
        <S.LaunchTrialText>{t('trialMiner.launchingTrial')}</S.LaunchTrialText>
      </S.LaunchContentWrapper>
      <S.LaunchingTrialDescription>
        {t('trialMiner.launchingTrialDescription')}
      </S.LaunchingTrialDescription>
    </S.TrialStartDelayBanner>
  );
};
